// navigator.clipboard требует secure-context и user-gesture; при отказе — false,
// вызывающий показывает toast.error вместо тихого провала.
export async function copyText(text: string): Promise<boolean> {
  try {
    if (!navigator.clipboard?.writeText) return false
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}
